//references https://ios-resolution.com/
export function getDevices()
{
    var devicesCSV = "\
    Apple iPhone 14,1170,2532,2022,Apple,phone;\
    Apple iPhone 14 Plus,1284,2778,2022,Apple,phone;\
    Apple iPhone 14 Pro,1179,2556,2022,Apple,phone;\
    Apple iPhone 14 Pro Max,1290,2796,2022,Apple,phone;\
    Apple iPhone 15,1179,2556,2023,Apple,phone;\
    Apple iPhone 15 Pro Max,1290,2796,2023,Apple,phone;\
    Apple iPhone 15 Pro,1179,2556,2023,Apple,phone;\
    Apple iPhone 15 Plus,1290,2796,2023,Apple,phone;\
    Apple iPhone 16 Pro Max,1320,2868,2024,Apple,phone;\
    Apple iPhone 16,1179,2556,2024,Apple,phone;\
    Apple iPhone 16 Pro,1206,2622,2024,Apple,phone;\
    Apple iPhone 16e,1170,2532,2025,Apple,phone;\
    Apple iPhone 16 Plus,1290,2796,2024,Apple,phone;\
    Apple iPhone 17 Pro Max,1320,2868,2025,Apple,phone;\
    Apple iPhone 17,1206,2622,2025,Apple,phone;\
    Apple iPhone 17 Pro,1206,2622,2025,Apple,phone;\
    Apple iPhone,320,480,2007,Apple,phone;\
    Apple iPhone 3G,320,480,2008,Apple,phone;\
    Apple iPhone 3GS,320,480,2009,Apple,phone;\
    Apple iPhone 4,640,960,2010,Apple,phone;\
    Apple iPhone 4s,640,960,2011,Apple,phone;\
    Apple iPhone 5,640,1136,2012,Apple,phone;\
    Apple iPhone 5s,640,1136,2013,Apple,phone;\
    Apple iPhone 5c,640,1136,2013,Apple,phone;\
    Apple iPhone 6,750,1334,2014,Apple,phone;\
    Apple iPhone 6 Plus,1080,1920,2014,Apple,phone;\
    Apple iPhone 6s,750,1334,2015,Apple,phone;\
    Apple iPhone 6s Plus,1080,1920,2015,Apple,phone;\
    Apple iPhone SE,640,1136,2016,Apple,phone;\
    Apple iPhone 7,750,1334,2016,Apple,phone;\
    Apple iPhone 7 Plus,1080,1920,2016,Apple,phone;\
    Apple iPhone 8,750,1334,2017,Apple,phone;\
    Apple iPhone 8 Plus,1080,1920,2017,Apple,phone;\
    Apple iPhone X,1125,2436,2017,Apple,phone;\
    Apple iPhone XS,1125,2436,2018,Apple,phone;\
    Apple iPhone XS Max,1242,2688,2018,Apple,phone;\
    Apple iPhone XR,828,1792,2018,Apple,phone;\
    Apple iPhone 11,828,1792,2019,Apple,phone;\
    Apple iPhone 11 Pro,1125,2436,2019,Apple,phone;\
    Apple iPhone 11 Pro Max,1242,2688,2019,Apple,phone;\
    Apple iPhone SE (2020),750,1334,2020,Apple,phone;\
    Apple iPhone 12,1170,2532,2020,Apple,phone;\
    Apple iPhone 12 mini,1080,2340,2020,Apple,phone;\
    Apple iPhone 12 Pro,1170,2532,2020,Apple,phone;\
    Apple iPhone 12 Pro Max,1284,2778,2020,Apple,phone;\
    Apple iPhone 13,1170,2532,2021,Apple,phone;\
    Apple iPhone 13 mini,1080,2340,2021,Apple,phone;\
    Apple iPhone 13 Pro,1170,2532,2021,Apple,phone;\
    Apple iPhone 13 Pro Max,1284,2778,2021,Apple,phone;\
    Apple iPhone SE (2022),750,1334,2022,Apple,phone;\
    Apple iPhone Air,1260,2736,2025,Apple,phone;\
    Apple iPad Wi-Fi,768,1024,2010,Apple,tablet;\
    Apple iPad 2 Wi-Fi,768,1024,2011,Apple,tablet;\
    Apple iPad 3 Wi-Fi,1536,2048,2012,Apple,tablet;\
    Apple iPad 4 Wi-Fi,1536,2048,2012,Apple,tablet;\
    Apple iPad 9.7 (2017),1536,2048,2017,Apple,tablet;\
    Apple iPad 9.7 (2018),1536,2048,2018,Apple,tablet;\
    Apple iPad 10.2 (2019),1620,2160,2019,Apple,tablet;\
    Apple iPad 10.2 (2020),1620,2160,2020,Apple,tablet;\
    Apple iPad 10.2 (2021),1620,2160,2021,Apple,tablet;\
    Apple iPad (2022),1640,2360,2022,Apple,tablet;\
    Apple iPad (2025),1640,2360,2025,Apple,tablet;\
    Apple iPad mini Wi-Fi,768,1024,2012,Apple,tablet;\
    Apple iPad mini 2,1536,2048,2013,Apple,tablet;\
    Apple iPad mini 3,1536,2048,2014,Apple,tablet;\
    Apple iPad mini 4 (2015),1536,2048,2015,Apple,tablet;\
    Apple iPad mini (2019),1536,2048,2019,Apple,tablet;\
    Apple iPad mini (2021),1488,2266,2021,Apple,tablet;\
    Apple iPad mini (2024),1488,2266,2024,Apple,tablet;\
    Apple iPad Air,1536,2048,2013,Apple,tablet;\
    Apple iPad Air 2,1536,2048,2014,Apple,tablet;\
    Apple iPad Air (2019),1668,2224,2019,Apple,tablet;\
    Apple iPad Air (2020),1640,2360,2020,Apple,tablet;\
    Apple iPad Air (2022),1640,2360,2022,Apple,tablet;\
    Apple iPad Air 11 (2024),1640,2360,2024,Apple,tablet;\
    Apple iPad Air 13 (2024),2048,2732,2024,Apple,tablet;\
    Apple iPad Air 11 (2025),1640,2360,2025,Apple,tablet;\
    Apple iPad Air 13 (2025),2048,2732,2025,Apple,tablet;\
    Apple iPad Pro 12.9 (2015),2048,2732,2015,Apple,tablet;\
    Apple iPad Pro 9.7 (2016),1536,2048,2016,Apple,tablet;\
    Apple iPad Pro 10.5 (2017),1668,2224,2017,Apple,tablet;\
    Apple iPad Pro 12.9 (2017),2732,2048,2017,Apple,tablet;\
    Apple iPad Pro 11 (2018),1668,2388,2018,Apple,tablet;\
    Apple iPad Pro 12.9 (2018),2048,2732,2018,Apple,tablet;\
    Apple iPad Pro 11 (2020),1668,2388,2020,Apple,tablet;\
    Apple iPad Pro 12.9 (2020),2048,2732,2020,Apple,tablet;\
    Apple iPad Pro 11 (2021),1668,2388,2021,Apple,tablet;\
    Apple iPad Pro 12.9 (2021),2048,2732,2021,Apple,tablet;\
    Apple iPad Pro 11 (2022),1668,2388,2022,Apple,tablet;\
    Apple iPad Pro 12.9 (2022),2048,2732,2022,Apple,tablet;\
    Apple iPad Pro 11 (2024),1668,2420,2024,Apple,tablet;\
    Apple iPad Pro 13 (2024),2064,2752,2024,Apple,tablet;\
    Samsung Galaxy A57,1080,2340,2026,Samsung,phone;\
    Samsung Galaxy A37,1080,2340,2026,Samsung,phone;\
    Samsung Galaxy S26 Ultra,1440,3120,2026,Samsung,phone;\
    Samsung Galaxy S26,1080,2340,2026,Samsung,phone;\
    Samsung Galaxy Z TriFold,1584,2160,2025,Samsung,phone;\
    Samsung Galaxy S25 FE,1080,2340,2025,Samsung,phone;\
    Samsung Galaxy Tab S11 Ultra,1848,2960,2025,Samsung,tablet;\
    Samsung Galaxy Tab S11,1600,2560,2025,Samsung,tablet;\
    Samsung Galaxy Tab S10 Lite,1320,2112,2025,Samsung,tablet;\
    Samsung Galaxy Z Fold7,1968,2184,2025,Samsung,phone;\
    Samsung Galaxy Z Flip7,1080,2520,2025,Samsung,phone;\
    Samsung Galaxy Z Flip7 FE,1080,2640,2025,Samsung,phone;\
    Samsung Galaxy S25 Edge,1440,3120,2025,Samsung,phone;\
    Samsung Galaxy Tab S10 FE,1440,2304,2025,Samsung,tablet;\
    Samsung Galaxy A56,1080,2340,2025,Samsung,phone;\
    Samsung Galaxy A36,1080,2340,2025,Samsung,phone;\
    Samsung Galaxy S25 Ultra,1440,3120,2025,Samsung,phone;\
    Samsung Galaxy S25,1080,2340,2025,Samsung,phone;\
    Samsung Galaxy Z Fold Special,1968,2184,2024,Samsung,phone;\
    Samsung Galaxy S24 FE,1080,2340,2024,Samsung,phone;\
    Samsung Galaxy Tab S10 Ultra,1848,2960,2024,Samsung,tablet;\
    Samsung Galaxy Z Fold6,1856,2160,2024,Samsung,phone;\
    Samsung Galaxy Z Flip6,1080,2640,2024,Samsung,phone;\
    Samsung Galaxy A55,1080,2340,2024,Samsung,phone;\
    Samsung Galaxy A35,1080,2340,2024,Samsung,phone;\
    Samsung Galaxy S24 Ultra,1440,3120,2024,Samsung,phone;\
    Samsung Galaxy S24,1080,2340,2024,Samsung,phone;\
    Samsung Galaxy S23 FE,1080,2340,2023,Samsung,phone;\
    Samsung Galaxy Tab S9 FE,1440,2304,2023,Samsung,tablet;\
    Samsung Galaxy Z Fold5,1812,2176,2023,Samsung,phone;\
    Samsung Galaxy Z Flip5,1080,2640,2023,Samsung,phone;\
    Samsung Galaxy Tab S9 Ultra,1848,2960,2023,Samsung,tablet;\
    Samsung Galaxy Tab S9,1600,2560,2023,Samsung,tablet;\
    Samsung Galaxy A54,1080,2340,2023,Samsung,phone;\
    Samsung Galaxy A34,1080,2340,2023,Samsung,phone;\
    Samsung Galaxy S23 Ultra,1440,3088,2023,Samsung,phone;\
    Samsung Galaxy S23,1080,2340,2023,Samsung,phone;\
    Samsung Galaxy Z Fold4,1812,2176,2022,Samsung,phone;\
    Samsung Galaxy Z Flip4,1080,2640,2022,Samsung,phone;\
    Samsung Galaxy S20 FE 2022,1080,2400,2022,Samsung,phone;\
    Samsung Galaxy A53 5G,1080,2400,2022,Samsung,phone;\
    Samsung Galaxy A33 5G,1080,2400,2022,Samsung,phone;\
    Samsung Galaxy S22 Ultra 5G,1440,3088,2022,Samsung,phone;\
    Samsung Galaxy S22 5G,1080,2340,2022,Samsung,phone;\
    Samsung Galaxy Tab S8 Ultra,1848,2960,2022,Samsung,tablet;\
    Samsung Galaxy Tab S8,1600,2560,2022,Samsung,tablet;\
    Samsung Galaxy S21 FE 5G,1080,2340,2022,Samsung,phone;\
    Samsung Galaxy A52s 5G,1080,2400,2021,Samsung,phone;\
    Samsung Galaxy Z Fold3 5G,1768,2208,2021,Samsung,phone;\
    Samsung Galaxy Z Flip3 5G,1080,2640,2021,Samsung,phone;\
    Samsung Galaxy Tab S7 FE,1600,2560,2021,Samsung,tablet;\
    Samsung Galaxy A52 5G,1080,2400,2021,Samsung,phone;\
    Samsung Galaxy A52,1080,2400,2021,Samsung,phone;\
    Samsung Galaxy A32,1080,2400,2021,Samsung,phone;\
    Samsung Galaxy S21 Ultra 5G,1440,3200,2021,Samsung,phone;\
    Samsung Galaxy S21 5G,1080,2400,2021,Samsung,phone;\
    Samsung Galaxy A32 5G,720,1600,2021,Samsung,phone;\
    Samsung Galaxy S20 FE 5G,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy S20 FE,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy A51 5G UW,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy Z Fold2 5G,1768,2208,2020,Samsung,phone;\
    Samsung Galaxy Note20 Ultra 5G,1440,3088,2020,Samsung,phone;\
    Samsung Galaxy Note20 Ultra,1440,3088,2020,Samsung,phone;\
    Samsung Galaxy Note20 5G,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy Note20,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy Tab S7,1600,2560,2020,Samsung,tablet;\
    Samsung Galaxy Z Flip 5G,1080,2636,2020,Samsung,phone;\
    Samsung Galaxy A51 5G,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy A31,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy S20 Ultra 5G,1440,3200,2020,Samsung,phone;\
    Samsung Galaxy S20 Ultra,1440,3200,2020,Samsung,phone;\
    Samsung Galaxy S20 5G UW,1440,3200,2020,Samsung,phone;\
    Samsung Galaxy S20 5G,1440,3200,2020,Samsung,phone;\
    Samsung Galaxy S20,1440,3200,2020,Samsung,phone;\
    Samsung Galaxy Z Flip,1080,2636,2020,Samsung,phone;\
    Samsung Galaxy Tab S6 5G,1600,2560,2020,Samsung,tablet;\
    Samsung Galaxy Note10 Lite,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy S10 Lite,1080,2400,2020,Samsung,phone;\
    Samsung Galaxy A51,1080,2400,2019,Samsung,phone;\
    Samsung Galaxy A30s,720,1560,2019,Samsung,phone;\
    Samsung Galaxy A50s,1080,2340,2019,Samsung,phone;\
    Samsung Galaxy Note10 5G,1080,2280,2019,Samsung,phone;\
    Samsung Galaxy Note10,1080,2280,2019,Samsung,phone;\
    Samsung Galaxy Tab S6,1600,2560,2019,Samsung,tablet;\
    Samsung Galaxy S10 5G,1440,3040,2019,Samsung,phone;\
    Samsung Galaxy S10,1440,3040,2019,Samsung,phone;\
    Samsung Galaxy S10e,1080,2280,2019,Samsung,phone;\
    Samsung Galaxy A50,1080,2340,2019,Samsung,phone;\
    Samsung Galaxy A30,1080,2340,2019,Samsung,phone;\
    Samsung Galaxy Tab S5e,1600,2560,2019,Samsung,tablet;\
    Samsung Galaxy Tab S4 10.5,1600,2560,2018,Samsung,tablet;\
    Samsung Galaxy Note9,1440,2960,2018,Samsung,phone;\
    Samsung Galaxy S Light Luxury,1080,2220,2018,Samsung,phone;\
    Samsung Galaxy S9,1440,2960,2018,Samsung,phone;\
    Samsung Galaxy Note8,1440,2960,2017,Samsung,phone;\
    Samsung Galaxy S8 Active,1440,2960,2017,Samsung,phone;\
    Samsung Galaxy Note FE,1440,2560,2017,Samsung,phone;\
    Samsung Galaxy S8,1440,2960,2017,Samsung,phone;\
    Samsung Galaxy Tab S3 9.7,1536,2048,2017,Samsung,tablet;\
    Samsung Galaxy Note7,1440,2560,2016,Samsung,phone;\
    Samsung Galaxy S7 active,1440,2560,2016,Samsung,phone;\
    Samsung Galaxy S7,1440,2560,2016,Samsung,phone;\
    Samsung Galaxy S7 edge,1440,2560,2016,Samsung,phone;\
    Samsung Galaxy Note5,1440,2560,2015,Samsung,phone;\
    Samsung Galaxy Note5 Duos,1440,2560,2015,Samsung,phone;\
    Samsung Galaxy S5 Neo,1080,1920,2015,Samsung,phone;\
    Samsung Galaxy S4 mini I9195I,540,960,2015,Samsung,phone;\
    Samsung Galaxy Tab S2 9.7,1536,2048,2015,Samsung,tablet;\
    Samsung Galaxy Tab S2 8.0,1536,2048,2015,Samsung,tablet;\
    Samsung Galaxy S6 active,1440,2560,2015,Samsung,phone;\
    Samsung Galaxy S6 edge,1440,2560,2015,Samsung,phone;\
    Samsung Galaxy S6 Duos,1440,2560,2015,Samsung,phone;\
    Samsung Galaxy S6,1440,2560,2015,Samsung,phone;\
    Samsung Galaxy A5 Duos,720,1280,2014,Samsung,phone;\
    Samsung Galaxy A5,720,1280,2014,Samsung,phone;\
    Samsung Galaxy A3 Duos,540,960,2014,Samsung,phone;\
    Samsung Galaxy A3,540,960,2014,Samsung,phone;\
    Samsung Galaxy S5 Plus,1080,1920,2014,Samsung,phone;\
    Samsung Galaxy Note Edge,1600,2560,2014,Samsung,phone;\
    Samsung Galaxy Note 4 Duos,1440,2560,2014,Samsung,phone;\
    Samsung Galaxy Note 4,1440,2560,2014,Samsung,phone;\
    Samsung Galaxy S5 LTE-A G901F,1080,1920,2014,Samsung,phone;\
    Samsung Galaxy S5 mini Duos,720,1280,2014,Samsung,phone;\
    Samsung Galaxy S Duos 3,480,800,2014,Samsung,phone;\
    Samsung Galaxy Star 2 Plus,480,800,2014,Samsung,phone;\
    Samsung Galaxy S5 mini,720,1280,2014,Samsung,phone;\
    Samsung Galaxy Star 2,320,480,2014,Samsung,phone;\
    Samsung Galaxy S5 Sport,1080,1920,2014,Samsung,phone;\
    Samsung Galaxy S5 LTE-A G906S,1440,2560,2014,Samsung,phone;\
    Samsung Galaxy Tab S 8.4 LTE,1600,2560,2014,Samsung,tablet;\
    Samsung Galaxy Tab S 8.4,1600,2560,2014,Samsung,tablet;\
    Samsung Galaxy Tab S 10.5 LTE,2560,1600,2014,Samsung,tablet;\
    Samsung Galaxy Tab S 10.5,2560,1600,2014,Samsung,tablet;\
    Samsung Galaxy S5 Active,1080,1920,2014,Samsung,phone;\
    Samsung Galaxy S5 Duos,1080,1920,2014,Samsung,phone;\
    Samsung Galaxy S5,1080,1920,2014,Samsung,phone;\
    Samsung Galaxy Star Trios S5283,240,320,2014,Samsung,phone;\
    Samsung Galaxy Note 3 Neo Duos,720,1280,2014,Samsung,phone;\
    Samsung Galaxy Note 3 Neo,720,1280,2014,Samsung,phone;\
    Samsung Galaxy Note Pro 12.2 LTE,2560,1600,2014,Samsung,tablet;\
    Samsung Galaxy Note Pro 12.2 3G,2560,1600,2014,Samsung,tablet;\
    Samsung Galaxy Note Pro 12.2,2560,1600,2014,Samsung,tablet;\
    Samsung Galaxy S4 Active LTE-A,1080,1920,2013,Samsung,phone;\
    Samsung Galaxy S Duos 2 S7582,480,800,2013,Samsung,phone;\
    Samsung Galaxy Star Pro S7260,480,800,2013,Samsung,phone;\
    Samsung Galaxy Note 3,1080,1920,2013,Samsung,phone;\
    Samsung Galaxy S4 zoom,540,960,2013,Samsung,phone;\
    Samsung Galaxy S II TV,480,800,2013,Samsung,phone;\
    Samsung Galaxy Star S5280,240,320,2013,Samsung,phone;\
    Samsung Galaxy S4 CDMA,1080,1920,2013,Samsung,phone;\
    Samsung Galaxy Note 8.0,800,1280,2013,Samsung,tablet;\
    Samsung Galaxy Note 8.0 Wi-Fi,800,1280,2013,Samsung,tablet;\
    Samsung Galaxy Note LTE 10.1 N8020,800,1280,2012,Samsung,phone;\
    Samsung Galaxy Stratosphere II I415,480,800,2012,Samsung,phone;\
    Samsung Galaxy S Relay 4G T699,480,800,2012,Samsung,phone;\
    Samsung Galaxy Note II N7100,720,1280,2012,Samsung,phone;\
    Samsung Galaxy Note II CDMA,720,1280,2012,Samsung,phone;\
    Samsung Galaxy Stellar 4G I200,480,800,2012,Samsung,phone;\
    Samsung Galaxy Note 10.1 N8000,800,1280,2012,Samsung,tablet;\
    Samsung Galaxy Note 10.1 N8010,800,1280,2012,Samsung,tablet;\
    Samsung Galaxy S Lightray 4G R940,480,800,2012,Samsung,phone;\
    Samsung Galaxy S Duos S7562,480,800,2012,Samsung,phone;\
    Samsung Galaxy S III T999,720,1280,2012,Samsung,phone;\
    Samsung Galaxy S III I747,720,1280,2012,Samsung,phone;\
    Samsung Galaxy S III CDMA,720,1280,2012,Samsung,phone;\
    Samsung Galaxy S Blaze 4G T769,480,800,2012,Samsung,phone;\
    Samsung Galaxy S II Skyrocket HD I757,720,1280,2012,Samsung,phone;\
    Samsung Galaxy Note T879,800,1280,2012,Samsung,phone;\
    Samsung Galaxy Note I717,800,1280,2012,Samsung,phone;\
    Samsung Galaxy S II Skyrocket i727,480,800,2011,Samsung,phone;\
    Samsung Galaxy S II HD LTE,720,1280,2011,Samsung,phone;\
    Samsung Galaxy Note N7000,800,1280,2011,Samsung,phone;\
    Samsung Galaxy S II I777,480,800,2011,Samsung,phone;\
    Samsung Galaxy S II X T989D,480,800,2011,Samsung,phone;\
    Samsung Galaxy S II T989,480,800,2011,Samsung,phone;\
    Samsung Galaxy S II Epic 4G Touch,480,800,2011,Samsung,phone;\
    Samsung Galaxy S II LTE i727R,480,800,2011,Samsung,phone;\
    Samsung Galaxy S II LTE I9210,480,800,2011,Samsung,phone;\
    Samsung Galaxy S II 4G I9100M,480,800,2011,Samsung,phone;\
    Samsung Galaxy S WiFi 5.0,480,800,2011,Samsung,phone;\
    Samsung Galaxy S 4G T959,480,800,2011,Samsung,phone;\
    Samsung Galaxy S21,1080,2400,,Samsung,phone;\
    Samsung Galaxy S7 mini,1080,1920,,Samsung,phone;\
    Samsung Galaxy S6 Plus,1080,1920,,Samsung,phone;\
    Xiaomi 15T Pro,1280,2772,2025,Xiaomi,phone;\
    Xiaomi 15T,1280,2772,2025,Xiaomi,phone;\
    Xiaomi Mix Flip 2,1224,2912,2025,Xiaomi,phone;\
    Xiaomi 15S Pro,1440,3200,2025,Xiaomi,phone;\
    Xiaomi 15 Ultra,1440,3200,2025,Xiaomi,phone;\
    Xiaomi 15,1200,2670,2024,Xiaomi,phone;\
    Xiaomi 15 Pro,1440,3200,2024,Xiaomi,phone;\
    Xiaomi 14T Pro,1220,2712,2024,Xiaomi,phone;\
    Xiaomi 14T,1220,2712,2024,Xiaomi,phone;\
    Xiaomi Mix Flip,1224,2912,2024,Xiaomi,phone;\
    Xiaomi Mix Fold 4,2224,2488,2024,Xiaomi,phone;\
    Xiaomi 14 Civi,1236,2750,2024,Xiaomi,phone;\
    Xiaomi 14,1200,2670,2023,Xiaomi,phone;\
    Xiaomi 14 Ultra,1440,3200,2024,Xiaomi,phone;\
    Xiaomi 14 Pro,1440,3200,2023,Xiaomi,phone;\
    Xiaomi 13T Pro,1220,2712,2023,Xiaomi,phone;\
    Xiaomi 13T,1220,2712,2023,Xiaomi,phone;\
    Xiaomi Mix Fold 3,1916,2160,2023,Xiaomi,phone;\
    Xiaomi 13 Ultra,1440,3200,2023,Xiaomi,phone;\
    Xiaomi 13 Pro,1440,3200,2022,Xiaomi,phone;\
    Xiaomi 13,1080,2400,2022,Xiaomi,phone;\
    Xiaomi 13 Lite,1080,2400,2023,Xiaomi,phone;\
    Xiaomi 12T Pro,1220,2712,2022,Xiaomi,phone;\
    Xiaomi 12T,1220,2712,2022,Xiaomi,phone;\
    Xiaomi Mix Fold 2,1914,2160,2022,Xiaomi,phone;\
    Xiaomi 12 Lite,1080,2400,2022,Xiaomi,phone;\
    Xiaomi 12S Ultra,1440,3200,2022,Xiaomi,phone;\
    Xiaomi 12S Pro,1440,3200,2022,Xiaomi,phone;\
    Xiaomi 12S,1080,2400,2022,Xiaomi,phone;\
    Xiaomi 12 Pro,1440,3200,2021,Xiaomi,phone;\
    Xiaomi 12,1080,2400,2021,Xiaomi,phone;\
    Xiaomi 12X,1080,2400,2021,Xiaomi,phone;\
    Xiaomi Mix 4,1080,2400,2021,Xiaomi,phone;\
    Xiaomi Mi 11X Pro,1080,2400,2021,Xiaomi,phone;\
    Xiaomi Mi 11X,1080,2400,2021,Xiaomi,phone;\
    Xiaomi Mi Mix Fold,1860,2480,2021,Xiaomi,phone;\
    Xiaomi Mi 11 Ultra,1440,3200,2021,Xiaomi,phone;\
    Xiaomi Mi 11 Pro,1440,3200,2021,Xiaomi,phone;\
    Xiaomi Mi 11i,1080,2400,2021,Xiaomi,phone;\
    Xiaomi Mi 11 Lite 5G,1080,2400,2021,Xiaomi,phone;\
    Xiaomi Mi 11 Lite,1080,2400,2021,Xiaomi,phone;\
    Xiaomi Mi 10S,1080,2340,2021,Xiaomi,phone;\
    Xiaomi Mi 10i 5G,1080,2400,2021,Xiaomi,phone;\
    Xiaomi Mi 11,1440,3200,2021,Xiaomi,phone;\
    Xiaomi Mi 10T Pro 5G,1080,2400,2020,Xiaomi,phone;\
    Xiaomi Mi 10T 5G,1080,2400,2020,Xiaomi,phone;\
    Xiaomi Mi 10T Lite 5G,1080,2400,2020,Xiaomi,phone;\
    Xiaomi Mi 10 Ultra,1080,2340,2020,Xiaomi,phone;\
    Xiaomi Mi Note 10 Lite,1080,2340,2020,Xiaomi,phone;\
    Xiaomi Mi 10 Youth 5G,1080,2400,2020,Xiaomi,phone;\
    Xiaomi Mi 10 Lite 5G,1080,2400,2020,Xiaomi,phone;\
    Xiaomi Mi 10 Pro 5G,1080,2340,2020,Xiaomi,phone;\
    Xiaomi Mi 10 5G,1080,2340,2020,Xiaomi,phone;\
    Xiaomi Mi Note 10 Pro,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi Note 10,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi CC9 Pro,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi Mix Alpha,2088,2250,,Xiaomi,phone;\
    Xiaomi Mi 9 Pro 5G,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi 9 Pro,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi 9 Lite,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi A3,720,1560,2019,Xiaomi,phone;\
    Xiaomi Mi CC9e,720,1560,2019,Xiaomi,phone;\
    Xiaomi Mi CC9,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi 9T Pro,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi 9T,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi Mix 3 5G,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi 9 Explorer,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi 9 SE,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi 9,1080,2340,2019,Xiaomi,phone;\
    Xiaomi Mi Play,1080,2280,2018,Xiaomi,phone;\
    Xiaomi Mi Mix 3,1080,2340,2018,Xiaomi,phone;\
    Xiaomi Mi 8 Pro,1080,2248,2018,Xiaomi,phone;\
    Xiaomi Mi 8 Lite,1080,2280,2018,Xiaomi,phone;\
    Xiaomi Mi Max 3,1080,2160,2018,Xiaomi,phone;\
    Xiaomi Mi Pad 4 Plus,1200,1920,2018,Xiaomi,tablet;\
    Xiaomi Mi Pad 4,1200,1920,2018,Xiaomi,tablet;\
    Xiaomi Mi 8 Explorer,1080,2248,2018,Xiaomi,phone;\
    Xiaomi Mi 8,1080,2248,2018,Xiaomi,phone;\
    Xiaomi Mi 8 SE,1080,2244,2018,Xiaomi,phone;\
    Xiaomi Mi Mix 2S,1080,2160,2018,Xiaomi,phone;\
    Xiaomi Mi Note 3,1080,1920,2017,Xiaomi,phone;\
    Xiaomi Mi Mix 2,1080,2160,2017,Xiaomi,phone;\
    Xiaomi Mi Max 2,1080,1920,2017,Xiaomi,phone;\
    Xiaomi Mi 6,1080,1920,2017,Xiaomi,phone;\
    Xiaomi Mi Pad 3,1536,2048,2017,Xiaomi,tablet;\
    Xiaomi Mi 5c,1080,1920,2017,Xiaomi,phone;\
    Xiaomi Mi 6 Plus,1080,1920,,Xiaomi,phone;\
    Xiaomi Mi Mix,1080,2040,2016,Xiaomi,phone;\
    Xiaomi Mi Note 2,1080,1920,2016,Xiaomi,phone;\
    Xiaomi Mi 5s Plus,1080,1920,2016,Xiaomi,phone;\
    Xiaomi Mi 5s,1080,1920,2016,Xiaomi,phone;\
    Xiaomi Mi Max,1080,1920,2016,Xiaomi,phone;\
    Xiaomi Mi 5,1080,1920,2016,Xiaomi,phone;\
    Xiaomi Mi 4s,1080,1920,2016,Xiaomi,phone;\
    Xiaomi Mi Pad 2,1536,2048,2015,Xiaomi,tablet;\
    Xiaomi Mi 4c,1080,1920,2015,Xiaomi,phone;\
    Xiaomi Mi 4i,1080,1920,2015,Xiaomi,phone;\
    Xiaomi Mi Note Pro,1440,2560,2015,Xiaomi,tablet;\
    Xiaomi Mi Note,1080,1920,2015,Xiaomi,phone;\
    Xiaomi Mi 4 LTE,1080,1920,2014,Xiaomi,phone;\
    Xiaomi Mi 4,1080,1920,2014,Xiaomi,phone;\
    Xiaomi Mi Pad 7.9,1536,2048,2014,Xiaomi,tablet;\
    Xiaomi Mi 3,1080,1920,2013,Xiaomi,phone;\
    Xiaomi Mi 2A,720,1280,2013,Xiaomi,phone;\
    Xiaomi Mi 2S,720,1280,2013,Xiaomi,phone;\
    Xiaomi Mi 2,720,1280,2012,Xiaomi,phone;\
    Xiaomi Mi 1S,480,854,2012,Xiaomi,phone;\
    Xiaomi 12 Lite NE,1080,2400,,Xiaomi,phone";

    var devicesSplit = devicesCSV.split(';');
    var devices = [];
    for(var index in devicesSplit)
    {
        var deviceLine = devicesSplit[index];
        var deviceValues = deviceLine.split(',');
        devices.push({
            "name" : deviceValues[0].trim(),
            "year" : deviceValues[3] ? deviceValues[3].trim() : "",
            "pixels": {
                "width" : Math.min(parseFloat(deviceValues[1]), parseFloat(deviceValues[2])),
                "height" : Math.max(parseFloat(deviceValues[1]), parseFloat(deviceValues[2]))
            },
            "brand" : (deviceValues[4] || "").trim(),
            "type"  : (deviceValues[5] || "").trim()
        })
    }

    return devices;

}
